import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './work-select.styles'
import FormSelect from 'pobble-components/dist/form-elements/form-select'

class WorkSelect extends Component {
  onChangeHandler(id) {
    const { onSelect, history, match } = this.props
    onSelect(id) &&
      history.push(
        `/assessment-files/${match.params.assessmentFileId}/works/${id}`
      )
  }

  render() {
    const { classes, works, count, selectedWorkId } = this.props
    return (
      <div
        className={(classes.container, 'metrics__moderation-af-work-select')}>
        <FormSelect
          className={classes.select}
          value={selectedWorkId}
          onChange={e => this.onChangeHandler(e.target.value)}>
          {works.map((work, index) => (
            <option value={work.id} key={work.id}>
              Work {index + 1}/{count}: {work.title}
            </option>
          ))}
        </FormSelect>
      </div>
    )
  }
}

export default injectSheet(styles)(WorkSelect)
